import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { Wine, Lock, User } from "lucide-react";
import { toast } from "sonner";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const AdminLoginPage = () => {
  const navigate = useNavigate();
  const [credentials, setCredentials] = useState({ username: "", password: "" });
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    // Check if already logged in
    const token = localStorage.getItem("adminToken");
    if (token) {
      navigate("/admin/dashboard");
    }
  }, [navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const response = await axios.post(`${API}/admin/login`, credentials);
      if (response.data.success) {
        localStorage.setItem("adminToken", response.data.token);
        localStorage.setItem("adminUser", response.data.username);
        localStorage.setItem("adminUserId", response.data.user_id);
        toast.success("Welcome back!");
        navigate("/admin/dashboard");
      }
    } catch (error) {
      toast.error("Invalid credentials");
    } finally {
      setLoading(false);
    }
  };

  return (
    <main className="min-h-screen flex items-center justify-center bg-[#050505]" data-testid="admin-login">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        className="w-full max-w-md p-8"
      >
        <div className="text-center mb-8">
          <Wine className="w-12 h-12 text-[#D4AF37] mx-auto mb-4" />
          <h1 className="text-3xl font-['Playfair_Display'] font-bold text-[#F5F5F0] mb-2">
            Admin Portal
          </h1>
          <p className="text-[#A1A1AA]">Mix & Mingle Events Management</p>
        </div>

        <form onSubmit={handleSubmit} className="space-y-6">
          <div>
            <label className="form-label">Username</label>
            <div className="relative">
              <User className="absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 text-[#D4AF37]" />
              <input
                type="text"
                value={credentials.username}
                onChange={(e) => setCredentials({ ...credentials, username: e.target.value })}
                className="w-full bg-[#121212] border border-[rgba(212,175,55,0.3)] text-[#F5F5F0] p-3 pl-12 focus:border-[#D4AF37] focus:outline-none transition-colors"
                placeholder="Enter username"
                required
                data-testid="username-input"
              />
            </div>
          </div>

          <div>
            <label className="form-label">Password</label>
            <div className="relative">
              <Lock className="absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 text-[#D4AF37]" />
              <input
                type="password"
                value={credentials.password}
                onChange={(e) => setCredentials({ ...credentials, password: e.target.value })}
                className="w-full bg-[#121212] border border-[rgba(212,175,55,0.3)] text-[#F5F5F0] p-3 pl-12 focus:border-[#D4AF37] focus:outline-none transition-colors"
                placeholder="Enter password"
                required
                data-testid="password-input"
              />
            </div>
          </div>

          <button
            type="submit"
            disabled={loading}
            className="btn-primary w-full flex items-center justify-center gap-2"
            data-testid="login-btn"
          >
            {loading ? (
              <>
                <div className="w-5 h-5 border-2 border-[#050505] border-t-transparent rounded-full animate-spin" />
                Signing in...
              </>
            ) : (
              "Sign In"
            )}
          </button>
        </form>

        <p className="text-center text-[#a1a1aa] text-sm mt-8">
          Protected admin area. Unauthorized access is prohibited.
        </p>
      </motion.div>
    </main>
  );
};

export default AdminLoginPage;
